<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" alt="logo"></a>
                    <p style="margin-top:-10px">
                        Tecnocap è specialista nella produzione industriale di chiusure metalliche per contenitori in vetro e plastica, bombole aerosol monoblocco in alluminio e bottiglie in alluminio largamente utilizzati per il confezionamento di prodotti alimentari, di bevande, alcolici e nei settori della cosmetica, della nutraceutica e della farmaceutica
                    </p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/newformacademy/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/new_form_academy/" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-1 col-md-6 col-sm-6"></div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Login</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Discenti</a></li>
                        <li><a href="https://discentya.newformacademy.it/login.php" target="_blank">Docenti</a></li>
                        <li><a href="https://discentya.newformacademy.it/login.php" target="_blank">Partners</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Dove Siamo</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Via S. Massimo 301<br>80035 Nola (NA) - Italia</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+393701587002">Telefono: (+39) 370-1587002</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:formazione@newformacademy.it">formazione@newformacademy.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+557854578964">Lunedì-Venerdì: 09:00÷18:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2023 New Form Academy - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
